import { meshLog, SPGet, SPSet, SPRemove } from "./spUtils";
import axios from 'axios';
import { decryptByAes256CBC } from './secret/aesCBC';
import PubSub from 'pubsub-js';
import { getRandomStr } from "./dataUtils";
import { AesKey } from "../const/infoConst";
import { exportTimeInterval } from "./timeUtils";
import { IsMeasureyOrDongle } from "./pidUtils";

//--例
export const saveGroupInfor = (groupInfo) => {
    //meshLog("修改参数:", areaItem);
    let groupList = JSON.parse(SPGet("groupList"));
    const daylightModel = groupInfo.daylightModel
    const motionModel = groupInfo.motionModel
    for (let i = 0; i < groupList.length; i++) {
        if (groupList[i].groupID == groupInfo.groupID) {
            groupList[i].isOnOff = groupInfo.isOnOff;
            groupList[i].cctLevel = groupInfo.cctLevel;
            groupList[i].dimLevel = groupInfo.dimLevel;
            groupList[i].detectionArea = motionModel.detectionSensitivity;
            groupList[i].motionSensorEnabled = motionModel.isEnabled;
            groupList[i].holdTime = motionModel.holdTime;
            groupList[i].maxLight = motionModel.maxLight;
            groupList[i].standbyPeriod = motionModel.standbyPeriod;
            groupList[i].standbyDim = motionModel.standbyDimLevel;
            groupList[i].daylightSensor = daylightModel.isEnabled;
            groupList[i].daylightThreshold = daylightModel.threshold;
            groupList[i].dhEnabled = daylightModel.isDaylightHarvesting

        }
    }
    //meshLog('groupList', groupList);
    SPRemove('groupList');//删除loaclstorage上的areaSetx
    SPSet('groupList', JSON.stringify(groupList))
    // meshLog("areaSetx:", areaSetx);
    return groupList
}


//上传profile
export const profileDataUpload = (json) => {
    let str = JSON.stringify(json);


}

//获取网关、计量设备、计量dongle
export const get_measureyOrDongle = () => {
    let arr = JSON.parse(SPGet("nodes"));
    let str = '';
    for (let i = 0; i < arr.length; i++) {
        if (IsMeasureyOrDongle(arr[i].pid)) {
            let mac = arr[i].macAddress;
            if (str.length > 0) {
                str += ',';
            }
            str = str + mac.substring(10, 12) + mac.substring(8, 10) + mac.substring(6, 8) + mac.substring(4, 6) + mac.substring(2, 4) + mac.substring(0, 2);
        }
    }
    meshLog('计量', str);
    return str;
}




//profile-mesh初始化数据
export const get_jsonData = (email, name, uuid) => {
    let json = {
        "dayScheduleList": [], "weekScheduleList": [], "sceneList": [], "groupList": get_groupList(1, "Group", "icon_light_fixture1"),
        "isEnableAlarm": false, "mapModel": [], "meshID": getRandomStr(8), "meshKey": getRandomStr(12), "meshName": name,
        "meshRandom": getRandomStr(8), "meshUUID": uuid, "nodes": [], "provisionerInfo": inner_provisionerInfo(email),
        "provisionerMac": getRandomStr(12), "virtualGroupList": [], "zoneList": inner_zoneList()
    };
    meshLog('json', json);
    return json;
}

export const get_groupList = (groupID, name, groupImgName) => {
    let arr = [];
    arr[0] = {
        "angleLevel": 90, "annulTestModel": inner_annulTestModel(), "cctLevel": 0, "cctModeArray": inner_cctModeArray(),
        "customSceneModel": inner_customSceneModel(), "daylightModel": inner_daylightModel(), "dimLevel": 100, "downCCTLevel": 0,
        "downDimLevel": 100, "groupID": groupID, "groupImgName": groupImgName, "isDownOnOff": true, "isEnableBeamAngle": false,
        "isEnableVGroup": true, "isFcMode": true, "isOnOff": true, "isUpOnOff": true, "manulTestModel": inner_annulTestModel(),
        "maxTrim": 100, "minTrim": 0, "monthlyTestModel": inner_annulTestModel(), "motionModel": inner_detectionSensitivity(),
        "name": name, "powerValue": 100, "upCCTLevel": 0, "upDimLevel": 100, "zoneID": 1
    };
    return arr;
}

//临时数据
function inner_annulTestModel() {
    let model = { "day": 14, "hour": 10, "isOnOff": false, "minute": 0, "month": 9, "year": 2025 };
    return model;
}
function inner_cctModeArray() {
    let arr = [];
    arr[0] = 3000;
    arr[1] = 3500;
    arr[2] = 4000;
    return arr;
}
function inner_daylightModel() {
    return { "isDaylightHarvesting": false, "isEnabled": false, "threshold": 200 };
}
function inner_detectionSensitivity() {
    return { "detectionSensitivity": 2, "holdTime": 600, "isEnabled": true, "maxLight": 100, "motionMode": 1, "standbyDimLevel": 20, "standbyPeriod": 600, "vacantlevel": 0 };
}
function inner_customSceneModel() {
    return { "daylightModel": inner_daylightModel(), "motionModel": inner_detectionSensitivity() }
}
function inner_provisionerInfo(email) {
    let time = exportTimeInterval() + "";
    return { "accountEmail": email, "meshVersion": 1, "osVersion": "1.0", "phoneModel": "network", "platform": "Web", "timestamp": time }
}
function inner_zoneList() {
    let arr = [];
    arr[0]={ "dimLevel": 100, "isOnOff": false, "name": "Zone", "zoneID": 1 };
    return arr;
}

//--例
export const saveDeviceInfor = (nodes) => {
    meshLog("修改参数:", nodes);
    // let deviceList = []
    for (let i = 0; i < nodes.length; i++) {
        nodes[i]["online"]=1;
        nodes[i]["brightness"]=0;
        nodes[i]["is_on"]=1;
        nodes[i]["dev_type"]=0;
    }
    SPRemove('nodes');//删除loaclstorage上的areaSetx
    SPSet("nodes", JSON.stringify(nodes))
    // meshLog("areaSetx:", areaSetx);
    // return groupList
}
